module.exports = __webpack_public_path__ + "static/media/samsung-s21-frame.c6349689.png";